module.exports = __webpack_public_path__ + "img/logo.8934e4b1.svg";